import type { FC, MouseEvent } from 'react';
import { FormattedMessage } from 'react-intl';

import { useEditStore } from '@xing-com/crate-entity-pages-entity-pages-shared-context-edit-context';
import { usePageContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';
import { List } from '@xing-com/list';
import type { PopOverType } from '@xing-com/pop-over';

import { useAbsoluteUrl } from '../../../hooks/use-absolute-url/use-absolute-url';

import * as Styled from './news-item-menu.styles';

type NewsItemMenuProps = {
  authorUrn: string;
  popOver: PopOverType;
};
export const NewsItemMenu: FC<NewsItemMenuProps> = ({ authorUrn, popOver }) => {
  const isEditing = useEditStore(({ isEditing }) => isEditing);
  const { pageContext } = usePageContext();

  const xbmUrl = isEditing
    ? `/brandmanager/${pageContext.pageSlug}/news-reach`
    : '';
  const absoluteXbmUrl = useAbsoluteUrl(xbmUrl);

  const handleOnClick = (ev: MouseEvent) => {
    ev.stopPropagation();
    ev.preventDefault();

    window.open(
      absoluteXbmUrl + '?sc_o=entity_page_news_module_more_statistics'
    );
  };

  return (
    <Styled.MenuContainer
      onOutsideClick={popOver.handleHide}
      triggerRef={popOver.triggerRef}
      show={popOver.show}
      isInFlow={true}
    >
      <List>
        <Styled.ListItem>
          <Styled.ReportButton
            targetUrn={pageContext.globalId}
            authorUrn={authorUrn}
          >
            <FormattedMessage id="EP_REPORT_NEWS_ITEM" />
          </Styled.ReportButton>
        </Styled.ListItem>
        {absoluteXbmUrl ? (
          <Styled.ListItem>
            <Styled.TextButton
              size="small"
              href={absoluteXbmUrl}
              target="_blank"
              rel="noopener nofollow"
              data-testid="xbm-button"
              onClick={handleOnClick}
            >
              <FormattedMessage id="NEWS_MODULE_SHOW_STATISTICS" />
            </Styled.TextButton>
          </Styled.ListItem>
        ) : null}
      </List>
    </Styled.MenuContainer>
  );
};
